/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";



function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {

    state.cards = [
      { id: 0, card_number: "Select Card", balance: null, disabled: true },
      { id: 1, card_number: "XXXX XXXX XXXX 1234", balance: 1000 },
      { id: 2, card_number: "XXXX XXXX XXXX 9876", balance: 500 },
      { id: 3, card_number: "XXXX XXXX XXXX 6543", balance: 2000 },
      { id: 4, card_number: "XXXX XXXX XXXX 3210", balance: 800 },
      { id: 5, card_number: "XXXX XXXX XXXX 5678", balance: 1500 }
    ];

    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();



  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: ""
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: ""
        }, {
          label: t().home_acc_info.navbar.trends,
          route: ""
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            m("div", { "class": "separator my-10" }),

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().card_to_card.sidebar_labels.top_up,
                    icon: "bi bi-book",
                    route: "/funds"
                  },
                  {
                    label: t().card_to_card.sidebar_labels.card_to_card,
                    icon: "bi bi-book",
                    route: "/cardToCard",
                    routesToActivate: ["/cardToCard/single", "/cardToCard/bulk"]
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", { "class": "d-flex flex-column container-xxl" },
                  m("div", {
                    "class": "app-content", "id": "kt_app_content", style: {
                      "flex-grow": 1,
                      "flex-basis": "auto",
                    }
                  },
                    m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" },
                      [
                        m("div", { "class": "row" }, [
                          m("div", { "class": "col-12" }, [
                            m("div", { "class": "card mb-3" }, [
                              m("div", { "class": "card-header" }, [
                                m("h1", { "class": "card-title" }, "Card To Card Transaction"),
                              ]),

                              m("div", { "class": "card-body" }, [
                                m("div", { "class": "row" }, [
                                  m("div", { "class": "col-sm-6 col-md-6 col-lg-6" }, [
                                    m("div", { "class": "d-flex justify-content-start", "data-kt-customer-table-toolbar": "base", style: { "padding-top": "10px" } }, [
                                      m("div", { "class": "form-check form-check-inline" }, [
                                        m("div", { "class": "form-check form-check-custom form-check-solid" },
                                          [
                                            m("input", {
                                              "class": "form-check-input", "type": "checkbox", "value": "1", checked: true, "id": "flexCheckDefault", "onchange": () => {
                                                m.route.set("/cardToCard/single")
                                                location.reload()
                                              }
                                            }),
                                            m("label", { "class": "form-check-label", "for": "flexCheckDefault" },
                                              t().single_card_to_card_complete.toolbar_actions.single,
                                            )
                                          ]
                                        ),
                                      ]),
                                      m("div", { "class": "form-check form-check-inline" }, [
                                        m("div", { "class": "form-check form-check-custom form-check-solid" },
                                          [
                                            m("input", {
                                              "class": "form-check-input",
                                              "type": "checkbox",
                                              "value": "1",
                                              "id": "flexCheckDefault",
                                              "onchange": () => {
                                                m.route.set("/cardToCard/bulk")
                                                location.reload()
                                              }
                                            }),
                                            m("label", { "class": "form-check-label", "for": "flexCheckDefault" },
                                              t().single_card_to_card_complete.toolbar_actions.bulk,
                                            )
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  m("div", { "class": "col-sm-12 col-md-6 col-lg-6" }, [
                                    m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base" },
                                      m("button", { "class": "btn btn-primary", onclick: () => history.back() }, [
                                        m("i", { "class": "bi bi-arrow-left" }),
                                        "Back"
                                      ])
                                    )
                                  ])
                                ])
                              ])
                            ]),
                          ]),
                          m("div", { "class": "col-md-6" }, [
                            m("div", {
                              "class": "card mb-3"
                            }, [
                              m("div", { "class": "card-body" }, [
                                m("h5", { "class": "card-title" }, "From Card"),
                                m("select", {
                                  "class": "form-select", "aria-label": "Select Card", onchange: (e) => {
                                    state.selectedCard = e.target.value;
                                  }
                                },
                                  state.cards.map(card => m("option", { "value": card.id }, card.card_number))
                                ),
                                !state.selectedCard ? null : [
                                  m("div", { "class": "separator my-10" }),
                                  m("div", { "class": "table-responsive" },
                                    m("table", { "class": "table table-row-dashed table-row-gray-300" },
                                      [
                                        m("tbody",
                                          [
                                            m("tr",
                                              [
                                                m("td", m("b", "Name")),
                                                m("td", "Sample Name")
                                              ]
                                            ),
                                            m("tr",
                                              [
                                                m("td", m("b", "Card Number")),
                                                m("td", "4111 1111 1111 1111")
                                              ]
                                            ),
                                            m("tr",
                                              [
                                                m("td", m("b", "Cards")),
                                                m("td", "5")
                                              ]
                                            ),
                                            m("tr",
                                              [
                                                m("td", m("b", "Balance")),
                                                m("td", "$1,000.00")
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ),
                                  !state.selectedToCard ? null : [m("div", { "class": "mb-10" },
                                    [
                                      m("label", { "class": "form-label" },
                                        "Enter Amount"
                                      ),
                                      m("input", { "class": "form-control", "type": "email", "placeholder": "1223456", "autocomplete": "email" }),
                                      m("div", { "data-lastpass-icon-root": "", "style": { "position": "relative !important", "height": "0px !important", "width": "0px !important", "float": "left !important" } })
                                    ]
                                  ),
                                  m("div", { "class": "mb-10" },
                                    [
                                      m("label", { "class": "form-label" },
                                        "New Balance"
                                      ),
                                      m("input", { "class": "form-control", "type": "email", "placeholder": "40560", "autocomplete": "email" }),
                                      m("div", { "data-lastpass-icon-root": "", "style": { "position": "relative !important", "height": "0px !important", "width": "0px !important", "float": "left !important" } })
                                    ]
                                  )]
                                ]])
                            ]),

                          ]),
                          m("div", { "class": "col-md-6" }, [
                            m("div", {
                              "class": "card mb-3"
                            }, [
                              m("div", { "class": "card-body" }, [
                                m("h5", { "class": "card-title" }, "To Card"),
                                m("select", {
                                  "class": "form-select", "aria-label": "Select Card", onchange: (e) => {
                                    state.selectedToCard = e.target.value;
                                  }
                                },
                                  [
                                    {
                                      id: "instruction",
                                      card_number: "Select a Card"
                                    },
                                    {
                                      id: "card1",
                                      card_number: "4111 XXXX XXXX 1111"
                                    },
                                    {
                                      id: "card2",
                                      card_number: "5105 XXXX XXXX 5100"
                                    },
                                    {
                                      id: "card3",
                                      card_number: "3782 XXXX XXXX 005"
                                    },
                                    {
                                      id: "card4",
                                      card_number: "6011 XXXX XXXX 1117"
                                    },
                                    {
                                      id: "card5",
                                      card_number: "3528 XXXX XXXX 9100"
                                    }
                                  ].map(card => m("option", { "value": card.id }, card.card_number))
                                ),
                                !state.selectedToCard ? null : [m("div", { "class": "separator my-10" }),
                                m("div", { "class": "table-responsive" },
                                  m("table", { "class": "table table-row-dashed table-row-gray-300" },
                                    [
                                      m("tbody",
                                        [
                                          m("tr",
                                            [
                                              m("td", m("b", "Name")),
                                              m("td", "Sample Name")
                                            ]
                                          ),
                                          m("tr",
                                            [
                                              m("td", m("b", "Card Number")),
                                              m("td", "4111 1111 1111 1111")
                                            ]
                                          ),
                                          m("tr",
                                            [
                                              m("td", m("b", "Cards")),
                                              m("td", "5")
                                            ]
                                          ),
                                          m("tr",
                                            [
                                              m("td", m("b", "Balance")),
                                              m("td", "$1,000.00")
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ),
                                m("div", { "class": "mb-10" },
                                  [
                                    m("label", { "class": "form-label" },
                                      "New Balance"
                                    ),
                                    m("input", { "class": "form-control", "type": "email", "placeholder": "20,000", "autocomplete": "email" }),
                                    m("div", { "data-lastpass-icon-root": "", "style": { "position": "relative !important", "height": "0px !important", "width": "0px !important", "float": "left !important" } })
                                  ]
                                ),]
                              ])
                            ]),

                          ]),
                          !state.selectedToCard ? null : [m("div", { "class": "col-md-6" }, [
                            m("button", { "class": "btn btn-secondary w-100" },
                              "Cancel"
                            )
                          ]),
                          m("div", { "class": "col-md-6" }, [
                            m("button", { "class": "btn w-100", "style": { "backgroundColor": "teal", "color": "white" } },
                              "Complete"
                            )
                          ])]
                        ]),

                      ]
                    )),

                ),
                // <!--end::Content-->


              ]),

              // <!--end::Inbox App - Messages -->

            ]),

            // <!--end::Content-->
          ]),
          m(footer)

        ]),

      ])

    ];
  }
};
